export const validations = {
  required: (item) => {
    const { value } = item;
    return Boolean(value && value.toString().trim());
  },
  minLength: (item, config) => {
    const { value } = item;
    const { minLength } = config;

    return Boolean(value) && value.toString().length >= minLength;
  },
  maxLength: (item, config) => {
    const { value } = item;
    const { maxLength } = config;

    return Boolean(value) && value.toString().length <= maxLength;
  },
  pattern: (item, config) => {
    const { value } = item;
    const { pattern } = config;
    const regex = new RegExp(pattern);

    return regex.test(value);
  },
};

export const addValidation = (name, validation) => {
  validations[name] = validation;
};
